import React from "react";
import styles from "./footer.module.css";
import { images, svg } from "../../assets";
import { Link, useLocation } from "react-router-dom";
import url from "../../assets/url";
import { useLanguage } from "../../languageContext";

const Footer = () => {
  const { pathname } = useLocation();
  const { translate } = useLanguage();

  if (pathname === "/") return null;

  return (
    <div className={styles.container}>
      {/* <div className={styles.footerLogo}>
        <img alt="Logo" src={images.logo} />
      </div> */}

      <div className={styles.footerLinks}>
        <h2>{translate("f1")}</h2>

        <div className={styles.menuLink}>
          <Link to="/">{translate("h1")}</Link>
        </div>
        <div className={styles.menuLink}>
          <Link to="/managementstaff">{translate("h2")}</Link>
        </div>
        <div className={styles.menuLink}>
          <Link to="/workzone">{translate("h6")}</Link>
        </div>
        <div className={styles.menuLink}>
          <Link to="/about-us">{translate("h12")}</Link>
        </div>
        <div className={styles.menuLink}>
          <Link to="/contact">{translate("h17")}</Link>
        </div>
      </div>
      <div className={styles.office}>
        <h2>{translate("f2")}</h2>

        <div className={styles.officeTitle}>
          <img src={svg.marker} alt="" />
          <a href={url.DUBAI_MAP} target="_blank" rel="noreferrer">
            Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E.
          </a>
        </div>
      </div>

      {/* İLETİŞİM */}
      <div className={styles.contact}>
        <h2>{translate("f3")}</h2>

        {/* Telefonlar */}
        <div className={styles.contactPhone}>
          <div>
            <p><a>İbrahim Aydın</a></p>
            <img src={svg.phone} alt="" />
            <a href="tel:+971543598144">+971 54 359 8144</a>
          </div>
          <div>
            <p><a>Pınar Yiğit</a></p>
            <img src={svg.phone} alt="" />
            <a href="tel:+971542718144">+971 54 271 8144</a>
          </div>
        </div>
        <div className={styles.contactMail}>
          <img src={svg.mail} alt="" />
          <a href="mailto:ibrahim.aydin@stratixbusiness.me">ibrahim.aydin@stratixbusiness.me</a>
        </div>
        <div className={styles.contactMail}>
          <img src={svg.mail} alt="" />
          <a href="mailto:pinar.yigit@stratixbusiness.me">pinar.yigit@stratixbusiness.me</a>
        </div>
        <div className={styles.footerMedia}>
          <a href={url.INSTA} target="_blank" rel="noreferrer">
            <img src={svg.insta} alt="Instagram" />
          </a>
          <a href={url.LINKD} target="_blank" rel="noreferrer">
            <img src={svg.linkd} alt="LinkedIn" />
          </a>
          <a href={url.TIKTOK} target="_blank" rel="noreferrer">
            <img src={svg.tiktok} alt="Tiktok" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
